import { HttpClient } from 'shared/libs/http';
import { ApiResponseDto } from 'shared/types';

export class CvCommentApiService {
   public static addEmployerComment(dto: { id: number | string; comment: string }) {
      return HttpClient.post<ApiResponseDto<string>>(`/job_apply/${dto.id}/comment`, {
         comment: dto.comment,
      });
   }

   public static deleteEmployerComment(dto: { id: number | string }) {
      return HttpClient.delete<ApiResponseDto<string>>(`/job_apply/${dto.id}/comment`);
   }
}
